import { render, staticRenderFns } from "./desempenho-atendente-detalhe.vue?vue&type=template&id=1d45fc01&scoped=true"
import script from "./desempenho-atendente-detalhe.vue?vue&type=script&lang=js"
export * from "./desempenho-atendente-detalhe.vue?vue&type=script&lang=js"
import style0 from "./desempenho-atendente-detalhe.vue?vue&type=style&index=0&id=1d45fc01&prod&scoped=true&lang=css"
import style1 from "./desempenho-atendente-detalhe.vue?vue&type=style&index=1&id=1d45fc01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d45fc01",
  null
  
)

export default component.exports